export type SupportedLanguage = "en" | "es" | "fr";

export interface LanguageInfo {
  code: SupportedLanguage;
  name: string;
  nativeName: string;
  dir: "ltr" | "rtl";
}

export const SUPPORTED_LANGUAGES: LanguageInfo[] = [
  { code: "en", name: "English", nativeName: "English", dir: "ltr" },
  { code: "es", name: "Spanish", nativeName: "Español", dir: "ltr" },
  { code: "fr", name: "French", nativeName: "Français", dir: "ltr" },
];

export const DEFAULT_LANGUAGE: SupportedLanguage = "en";
export const STORAGE_KEY_LANGUAGE = "webtemplate-language";
export const DEFAULT_NAMESPACE = "core";
